<template>
  <p class="font-15">
    <span class="font-weight-medium pr-1">
      <template v-if="linha.idproduto">Produto</template>
      <template v-else-if="linha.idcategoria">Categoria</template>
      <template v-else-if="linha.idsecao">Secao</template>
      <template v-else>Departamento</template>:
    </span>

    <span>
      <template v-if="linha.idproduto">{{ `${linha.idproduto} - ${linha.descricao_produto}` }}</template>
      <template v-else-if="linha.idcategoria">{{ `${linha.idcategoria} - ${linha.descricao_categoria}` }}</template>
      <template v-else-if="linha.idsecao">{{ `${linha.idsecao} - ${linha.descricao_secao}` }}</template>
      <template v-else>{{ `${linha.iddepartamento} - ${linha.descricao_departamento}` }}</template>
    </span>
  </p>
</template>

<script>
export default {
  name: "DescricaoNivelLinha",
  props: {
    linha: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
